// extracted by css-extract-rspack-plugin
export default {"cls1":"Instructor-cls1_BKx","cls2":"Instructor-cls2_KjR Instructor-cls1_BKx"};